// extracted by mini-css-extract-plugin
export default {"active":"kL06t2URKmM1m23iq2uI","specific":"i2KAlGqcvEYMCcgct4fS"};